const SET_NHIEM_VU_PAGING = (state, nhiemVuPaging) => {
  state.nhiemVuPaging = nhiemVuPaging;
};

const SET_VAN_BAN_TAO_NHIEM_VU = (state, vanBanTaoNhiemVu) => {
  state.vanBanTaoNhiemVu = vanBanTaoNhiemVu;
};

const SET_TAT_CA_DON_VI_TRONG_DON_VI_CHA = (state, tatCaDonViTrongDonViCha) => {
  state.tatCaDonViTrongDonViCha = tatCaDonViTrongDonViCha;
};

const SET_TAT_CA_CAN_BO_TRONG_DON_VI = (state, tatCacCanBoTrongDonVi) => {
  state.tatCacCanBoTrongDonVi = tatCacCanBoTrongDonVi;
};

const SET_TAT_CA_CAN_BO_CO_QUYEN_PHAN_XU_LY_TRONG_DON_VI = (
  state,
  tatCaCanBoCoQuyenPhanXuLyTrongDonVi
) => {
  state.tatCaCanBoCoQuyenPhanXuLyTrongDonVi = tatCaCanBoCoQuyenPhanXuLyTrongDonVi;
};

const TAO_NHIEM_VU_THANH_CONG = (state, danhSachNhiemVu) => {
  state.danhSachNhiemVu.push(
    Object.assign({}, danhSachNhiemVu, { id: state.nhiemVuId })
  );
};

const CAP_NHAT_NHIEM_VU_THANH_CONG = (state, danhSachNhiemVu) => {
  const editItemIndex = state.danhSachNhiemVu.findIndex(
    (obj) => obj.id === parseInt(danhSachNhiemVu.id)
  );
  state.danhSachNhiemVu[editItemIndex] = danhSachNhiemVu;
};

const XOA_NHIEM_VU_THANH_CONG = (state, danhSachNhiemVu) => {
  let objIndex = state.danhSachNhiemVu.findIndex(
    (item) => item.id === parseInt(danhSachNhiemVu.id)
  );
  state.danhSachNhiemVu.splice(objIndex, 1);
};

const TANG_ID_NHIEM_VU = (state) => {
  state.nhiemVuId++;
};

const LAY_CHI_TIET_NHIEM_VU_THANH_CONG = (state, nhiemVuId) => {
  state.nhiemVuId = nhiemVuId;
};

const LAY_LOAI_NHIEM_VU = (state, loaiNhiemVu) => {
  state.loaiNhiemVu = loaiNhiemVu;
};

const LAY_TAT_CA_LOAI_NHIEM_VU = (state, tatCaLoaiNhiemVu) => {
  state.tatCaLoaiNhiemVu = tatCaLoaiNhiemVu;
};

const LAY_DANH_SACH_THU_HOI_NHIEM_VU = (state, danhSachThuHoiNhiemVu) => {
  state.danhSachThuHoiNhiemVu = danhSachThuHoiNhiemVu;
};

const LAY_DANH_SACH_TRA_LAI_NHIEM_VU = (state, danhSachTraLaiNhiemVu) => {
  state.danhSachTraLaiNhiemVu = danhSachTraLaiNhiemVu;
};

const LAY_DANH_SACH_TRA_SO_LUONG_NHIEM_VU = (state, danhSachSoLuongNhiemVu) => {
  state.danhSachSoLuongNhiemVu = danhSachSoLuongNhiemVu;
};

const SET_DANH_SACH_NHIEM_VU = (state, danhSachNhiemVu) => {
  state.danhSachNhiemVu = danhSachNhiemVu;
};

const SET_DANH_SACH_TRANG_THAI = (state, danhSachTrangThai) => {
  state.danhSachTrangThai = danhSachTrangThai;
};

const LAY_DANH_SACH_NGUOI_GIAO_NHIEM_VU = (state, danhSachNguoiGiaoNhiemVu) => {
  state.danhSachNguoiGiaoNhiemVu = danhSachNguoiGiaoNhiemVu;
};

const SET_DANH_SACH_DON_VI_CA_NHAN = (state, danhSachDonViCaNhan) => {
  state.danhSachDonViCaNhan = danhSachDonViCaNhan;
};

const LAY_CHI_TIET_VAN_BAN_LIEN_QUAN = (
  state,
  danhSachChiTietVanBanLienQuan
) => {
  state.danhSachChiTietVanBanLienQuan = danhSachChiTietVanBanLienQuan;
};

const LAY_CHI_TIET_Y_KIEN_XU_LY = (state, danhSachChiTietYkienXuLy) => {
  state.danhSachChiTietYkienXuLy = danhSachChiTietYkienXuLy;
};

const LAY_DANH_SACH_LICH_SU_PHAN_XU_LY = (state, danhSachLichSuPhanXuLy) => {
  state.danhSachLichSuPhanXuLy = danhSachLichSuPhanXuLy;
};

const SET_TRANG_THAI_TINH_HINH_THUC_HIEN = (
  state,
  trangThaiTinhHinhThucHien
) => {
  state.trangThaiTinhHinhThucHien = trangThaiTinhHinhThucHien;
};

const SET_DANH_SACH_TINH_HINH_THUC_HIEN_NHIEM_VU = (
  state,
  danhSachTinhHinhThucHienNhiemVu
) => {
  state.danhSachTinhHinhThucHienNhiemVu = danhSachTinhHinhThucHienNhiemVu;
};

const SET_DANH_SACH_TINH_HINH_THUC_HIEN_CONG_VIEC = (
  state,
  danhSachTinhHinhThucHienContgViec
) => {
  state.danhSachTinhHinhThucHienContgViec = danhSachTinhHinhThucHienContgViec;
};

const SET_DANH_SACH_PHUONG_THUC_NHAN_NHIEM_VU = (
  state,
  danhSachPhuongThucNhanNhiemVu
) => {
  state.danhSachPhuongThucNhanNhiemVu = danhSachPhuongThucNhanNhiemVu;
};

const SET_DANH_SACH_LICH_SU_TRA_LAI_NHIEM_VU = (
  state,
  danhSachLichSuTraLaiNhiemVu
) => {
  state.danhSachLichSuTraLaiNhiemVu = danhSachLichSuTraLaiNhiemVu;
};

const SET_DANH_SACH_LICH_SU_CAP_NHAT_TINH_HINH_NHIEM_VU = (
  state,
  danhSachLichSuCapNhatTinhHinhNhiemVu
) => {
  state.danhSachLichSuCapNhatTinhHinhNhiemVu = danhSachLichSuCapNhatTinhHinhNhiemVu;
};

const SET_DANH_SACH_LICH_SU_THU_HOI_NHIEM_VU = (
  state,
  danhSachLichSuThuHoiNhiemVu
) => {
  state.danhSachLichSuThuHoiNhiemVu = danhSachLichSuThuHoiNhiemVu;
};

const SET_DANH_SACH_LICH_SU_DON_DOC_NHIEM_VU = (
  state,
  danhSachLichSuDonDocNhiemVu
) => {
  state.danhSachLichSuDonDocNhiemVu = danhSachLichSuDonDocNhiemVu;
};

const SET_DANH_SACH_DEM_LOAI_NHIEM_VU_CA_NHAN = (
  state,
  danhSachDemLoaiNhiemVuCaNhan
) => {
  state.danhSachDemLoaiNhiemVuCaNhan = danhSachDemLoaiNhiemVuCaNhan;
};

const SET_DANH_SACH_DEM_LOAI_CONG_VIEC_DON_VI = (
  state,
  danhSachDemLoaiCongViecDonVi
) => {
  state.danhSachDemLoaiCongViecDonVi = danhSachDemLoaiCongViecDonVi;
};

const SET_DANH_SACH_DEM_LOAI_CONG_VIEC_DV = (
  state,
  danhSachDemLoaiCongViecDV
) => {
  state.danhSachDemLoaiCongViecDV = danhSachDemLoaiCongViecDV;
};

const SET_DANH_SACH_DEM_LOAI_NHIEM_VU_DON_VI = (
  state,
  danhSachDemLoaiNhiemVuDonVi
) => {
  state.danhSachDemLoaiNhiemVuDonVi = danhSachDemLoaiNhiemVuDonVi;
};

const SET_DANH_SACH_DEM_LOAI_CONG_VIEC = (state, danhSachDemLoaiCongViec) => {
  state.danhSachDemLoaiCongViec = danhSachDemLoaiCongViec;
};

const SET_DANH_SACH_SO_DO_LUONG_NHIEM_VU = (
  state,
  danhSachSoDoLuongNhiemVu
) => {
  state.danhSachSoDoLuongNhiemVu = danhSachSoDoLuongNhiemVu;
};

const SET_KET_QUA_EXPORT_DANH_SACH_NHIEM_VU = (
  state,
  ketQuaExportDanhSachNhiemVu
) => {
  state.ketQuaExportDanhSachNhiemVu = ketQuaExportDanhSachNhiemVu;
};

const SET_DANH_SACH_NHIEM_VU_FROM_IMPORT_FILE = (
  state,
  danhSachNhiemVuFromImportFile
) => {
  state.danhSachNhiemVuFromImportFile = danhSachNhiemVuFromImportFile;
};

const SET_DANH_SACH_COT_NHIEM_VU_EXPORT = (state, danhSachCotNhiemVuExport) => {
  state.danhSachCotNhiemVuExport = danhSachCotNhiemVuExport;
};

const SET_DANH_SACH_COT_NHIEM_VU = (state, danhSachHienThiCotNhiemVu) => {
  state.danhSachHienThiCotNhiemVu = danhSachHienThiCotNhiemVu;
};

const SET_DANH_SACH_TAT_CA_DON_VI = (state, danhSachTatCaDonVi) => {
  state.danhSachTatCaDonVi = danhSachTatCaDonVi;
};

const CAP_NHAT_DANH_SACH_COT_NHIEM_VU = (
  state,
  danhSachHienThiCotNhiemVuCapNhat
) => {
  state.danhSachHienThiCotNhiemVuCapNhat = danhSachHienThiCotNhiemVuCapNhat;
};

const CAP_NHAT_DANH_SACH_COT_DANH_MUC = (
  state,
  DanhSachDanhMucCapNhat
) => {
  state.DanhSachDanhMucCapNhat = DanhSachDanhMucCapNhat;
};

const SET_DANH_SACH_COT_DANH_MUC = (state, DanhSachCotDanhMuc) => {
  state.DanhSachCotDanhMuc = DanhSachCotDanhMuc;
};

const DATA_FILTER_DASHBOARD = (state, data) => {
  state.dataFilterDashboard = data;
};

const SET_TAB_INDEX = (state, data) => {
  state.tabIndex = data;
};
const SET_TAB_TEXT = (state, data) => {
  state.tabText = data;
};
const SET_TAB_BACK = (state, data) => {
  state.indexTab = data;
};
export default {
  SET_TAB_INDEX,
  SET_DANH_SACH_COT_DANH_MUC,
  CAP_NHAT_DANH_SACH_COT_DANH_MUC,
  DATA_FILTER_DASHBOARD,
  SET_NHIEM_VU_PAGING,
  TAO_NHIEM_VU_THANH_CONG,
  CAP_NHAT_NHIEM_VU_THANH_CONG,
  XOA_NHIEM_VU_THANH_CONG,
  TANG_ID_NHIEM_VU,
  SET_VAN_BAN_TAO_NHIEM_VU,
  SET_TAT_CA_DON_VI_TRONG_DON_VI_CHA,
  LAY_CHI_TIET_NHIEM_VU_THANH_CONG,
  LAY_LOAI_NHIEM_VU,
  LAY_TAT_CA_LOAI_NHIEM_VU,
  SET_TAT_CA_CAN_BO_TRONG_DON_VI,
  LAY_DANH_SACH_THU_HOI_NHIEM_VU,
  LAY_DANH_SACH_TRA_LAI_NHIEM_VU,
  SET_TAT_CA_CAN_BO_CO_QUYEN_PHAN_XU_LY_TRONG_DON_VI,
  LAY_DANH_SACH_TRA_SO_LUONG_NHIEM_VU,
  SET_DANH_SACH_NHIEM_VU,
  LAY_DANH_SACH_NGUOI_GIAO_NHIEM_VU,
  SET_DANH_SACH_TRANG_THAI,
  SET_DANH_SACH_DON_VI_CA_NHAN,
  LAY_CHI_TIET_VAN_BAN_LIEN_QUAN,
  LAY_CHI_TIET_Y_KIEN_XU_LY,
  LAY_DANH_SACH_LICH_SU_PHAN_XU_LY,
  SET_TRANG_THAI_TINH_HINH_THUC_HIEN,
  SET_DANH_SACH_TINH_HINH_THUC_HIEN_NHIEM_VU,
  SET_DANH_SACH_TINH_HINH_THUC_HIEN_CONG_VIEC,
  SET_DANH_SACH_PHUONG_THUC_NHAN_NHIEM_VU,
  SET_DANH_SACH_LICH_SU_TRA_LAI_NHIEM_VU,
  SET_DANH_SACH_LICH_SU_CAP_NHAT_TINH_HINH_NHIEM_VU,
  SET_DANH_SACH_LICH_SU_THU_HOI_NHIEM_VU,
  SET_DANH_SACH_LICH_SU_DON_DOC_NHIEM_VU,
  SET_DANH_SACH_DEM_LOAI_NHIEM_VU_CA_NHAN,
  SET_DANH_SACH_DEM_LOAI_NHIEM_VU_DON_VI,
  SET_DANH_SACH_DEM_LOAI_CONG_VIEC,
  SET_DANH_SACH_SO_DO_LUONG_NHIEM_VU,
  SET_DANH_SACH_DEM_LOAI_CONG_VIEC_DON_VI,
  SET_DANH_SACH_DEM_LOAI_CONG_VIEC_DV,
  SET_KET_QUA_EXPORT_DANH_SACH_NHIEM_VU,
  SET_DANH_SACH_NHIEM_VU_FROM_IMPORT_FILE,
  SET_DANH_SACH_COT_NHIEM_VU_EXPORT,
  SET_DANH_SACH_COT_NHIEM_VU,
  CAP_NHAT_DANH_SACH_COT_NHIEM_VU,
  SET_DANH_SACH_TAT_CA_DON_VI,
  SET_TAB_BACK,
  SET_TAB_TEXT
};
